export function hasField<K extends PropertyKey>(obj: unknown, field: K): obj is Record<K, unknown> {
  return typeof obj === 'object' && obj !== null && field in obj;
}

export function isNotNullish<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}

export function difference<T>(s1: Set<T>, s2: Set<T>) {
  return new Set(
    [...s1].filter(v => !s2.has(v)),
  );
}

export function filterEmptyValue(object: Record<string, unknown>) {
  return Object.fromEntries(Object.entries(object).filter(([_, value]) => !!value));
}
